import { render, staticRenderFns } from "./CronogramaTitle.vue?vue&type=template&id=32448edf&"
import script from "./CronogramaTitle.vue?vue&type=script&lang=js&"
export * from "./CronogramaTitle.vue?vue&type=script&lang=js&"
import style0 from "./CronogramaTitle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports